/**
 * Generates an arry of step to be used as CSS gradient.
 *
 */
export const generateSteps = (
  colors: unknown[],
  weights?: number[],
): number[] => {
  const finalWeights: number[] = weights ?? Array(colors.length).fill(1)

  if (finalWeights.length !== colors.length) {
    throw new Error(
      'Cannot generate steps if color and weights are not of the same amount',
    )
  }

  const colorLength = colors.length
  const colorTotalWeight = finalWeights.reduce(
    (partialSum, el) => partialSum + el,
    0,
  )

  // Crea un array del doppio della dimensione e poi moltiplica per degli step basati sull'indice dell'array
  return Array(colorLength * 2)
    .fill(100)
    .map((el, index) => {
      const maxIndex = Math.round(index / 2)
      const calculatedWeight = finalWeights
        .slice(0, maxIndex)
        .reduce((partialSum, weight) => partialSum + weight, 0)

      return Math.floor(((el * calculatedWeight) / colorTotalWeight) * 10) / 10
    })
}
